import { jsx as _jsx } from "react/jsx-runtime";
import CheckEmptyIconSvg from '@assets/icons/check-empty-icon.svg';
const CheckEmptyIcon = () => {
    return (_jsx("img", { src: CheckEmptyIconSvg, alt: "check-empty-icon" }));
};
export default CheckEmptyIcon;
